import React, { useRef, useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ActionSection,
  ScrollableContent,
  MobileIcon,
  RupeeIcon,
} from "../Styles/InputStyles";
import { MdClose, MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import SelectOptionModal from "../SelectOptionModal";
import { ProfileSection } from "../Styles/PageStyles";
import moment from "moment";
import { FaRegBuilding } from "react-icons/fa";
import { capitalizeFirstLetter } from "../../helpers";

const AddDeal = ({
  handleClose,
  key,
  selectedData,
  addDealMutate,
  addDealLoading,
  selectedTableRow,
}) => {
  let formikRef = useRef(null);
  const [height, setHeight] = useState(window.innerHeight);
  const [isStageModalOpen, setIsStageModalOpen] = useState(false);

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [key]);

  const initialValues = {
    name: selectedTableRow?.name || "",
    mobile: selectedTableRow?.mobile || "",
    stage: "",
    budget: "",
    date: null,
    note: "",
    time: "",
  };

  const stageOptions = [
    { value: 1, label: "Inquiry" },
    { value: 2, label: "Visit Scheduled" },
    { value: 3, label: "Negotiation" },
    // { value: 4, label: "Closed" },
    // { value: 5, label: "Lost" },
  ];
  const stageOption = stageOptions.map((role) => ({
    label: role.label,
    value: role.value,
  }));

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Client name is required")
      .matches(
        /^[A-Za-z0-9.\s]+$/,
        "Only letters, numbers, spaces and dot are allowed.",
      )
      .min(3, "Name must be at least 3 characters long"),
    mobile: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
    stage: Yup.string().required("Stage is required"),
    budget: Yup.string()
      .required("Budget is required")
      .test(
        "budget-range",
        "Please enter a valid budget amount",
        function (value) {
          if (!value) return false;
          const numValue = parseInt(value);
          return numValue > 0 && numValue <= 100000000;
        },
      ),
    date: Yup.date()
      .nullable()
      .required("Next follow-up date is required")
      .min(new Date(), "Follow-up date cannot be in the past"),
  });

  const handleSubmit = (values) => {
    const formattedDate = values.date
      ? moment(values.date).format("YYYY-MM-DD HH:mm")
      : null;

    addDealMutate({
      inventoryId: selectedData.id,
      mobile: values.mobile,
      name: values.name,
      stage: values.stage,
      budget: values.budget,
      date: formattedDate,
      note: values.note,
      time: values.time,
      //---nagotiation---
      tenantBudget: values.tenantBudget || null,
      ownerExpected: values.ownerExpected || null,
      negotiationStage: values.negotiationStatus || null,
    });
  };
  const DEAL_NEGOTIATION_STATUS = {
    ONGOING: 1,
    TENANT_AGREED: 2,
    OWNER_AGREED: 3,
    FINAL_DISCUSSION: 4,
  };

  return (
    <Container style={{ height: `${height}px`, overflow: "auto" }}>
      <Header>
        <h1 className="text-white text-lg font-medium">Add Deal</h1>
        <button
          onClick={() => {
            if (formikRef.current) {
              formikRef.current.resetForm();
            }
            handleClose();
          }}
        >
          <MdClose color="white" size={24} />
        </button>
      </Header>

      <ProfileSection className="px-4 py-3 flex items-center justify-between">
        {/* Left: Icon + Info */}
        <div className="flex items-center gap-2">
          {/* Inventory Icon */}
          <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center">
            <FaRegBuilding className="text-gray-600" />
          </div>

          {/* Text Info */}
          <div className="flex flex-col">
            <p className="text-md font-medium text-gray-800">
              {capitalizeFirstLetter(selectedData?.inventoryName || "")}
            </p>
            <p className="text-xs text-gray-400">{selectedData?.address}</p>
          </div>
        </div>

        {/* Right: Budget */}
        {/* <div className="text-right">
            <p className="text-xs text-gray-400">Budget</p>
            <p className="text-lg font-bold text-green-600">
                ₹{selectedData?.budget || 0}
            </p>
        </div> */}
      </ProfileSection>

      <div className="px-6 h-full flex flex-col justify-between">
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          validateOnChange={true}
          validateOnBlur={true}
        >
          {({
            values,
            setFieldValue,
            handleChange,
            handleBlur,
            errors,
            touched,
            resetForm,
          }) => {
            const getCurrentStageLabel = () => {
              const selectedStage = stageOptions.find(
                (role) => role.value === values?.stage,
              );
              return selectedStage ? selectedStage.label : "Select stage";
            };

            const handleStageSelect = (selectedValue) => {
              setFieldValue("stage", selectedValue);
            };
            return (
              <Form autoComplete="off">
                <ScrollableContent className="max-h-[calc(100vh-180px)]">
                  <Wrapper>
                    {/* Client Name */}
                    <InputGroup>
                      <Label htmlFor="name">Client Name *</Label>
                      <FieldWrappers>
                        <Field
                          type="text"
                          name="name"
                          id="name"
                          className="w-full truncate"
                          placeholder="Enter client name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </FieldWrappers>
                      {errors.name && touched.name && (
                        <ErrorText>{errors.name}</ErrorText>
                      )}
                    </InputGroup>

                    {/* Client Mobile */}
                    <InputGroup>
                      <Label htmlFor="mobile">Mobile No. *</Label>
                      <FieldWrappers>
                        <MobileIcon />
                        <Field
                          type="text"
                          id="mobile"
                          name="mobile"
                          className="w-full truncate pl-5"
                          placeholder="Enter 10-digit mobile number"
                          value={values.mobile}
                          maxLength={10}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              setFieldValue("mobile", value);
                            }
                          }}
                          onBlur={handleBlur}
                        />
                      </FieldWrappers>
                      {errors.mobile && touched.mobile && (
                        <ErrorText>{errors.mobile}</ErrorText>
                      )}
                    </InputGroup>

                    {/* Stage with Selection Cards */}
                    <InputGroup>
                      <Label htmlFor="stage">Stage *</Label>
                      <FieldWrappers onClick={() => setIsStageModalOpen(true)}>
                        <Field
                          type="text"
                          name="stage"
                          id="stage"
                          autoComplete="off"
                          readOnly
                          value={getCurrentStageLabel()}
                          className="w-full border-none outline-none bg-transparent cursor-pointer"
                        />
                        <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                      </FieldWrappers>

                      {errors.stage && touched.stage && (
                        <p className="text-rose-600 text-sm mt-1">
                          {errors.stage}
                        </p>
                      )}
                    </InputGroup>

                    {/* Client Budget */}

                    <InputGroup>
                      <Label htmlFor="budget">Budget (₹) *</Label>
                      <FieldWrappers>
                        <RupeeIcon />
                        <Field
                          type="number"
                          name="budget"
                          id="budget"
                          className="w-full truncate pl-5"
                          placeholder="Enter budget amount"
                          min="1"
                          value={values.budget}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </FieldWrappers>
                      {errors.budget && touched.budget && (
                        <ErrorText>{errors.budget}</ErrorText>
                      )}
                    </InputGroup>

                    {/* Next Follow-up Date */}
                    <InputGroup>
                      <Label htmlFor="date">Next Follow-up Date *</Label>
                      <FieldWrappers>
                        <DatePicker
                          selected={values.date}
                          onChange={(date) => setFieldValue("date", date)}
                          showTimeSelect
                          timeIntervals={15}
                          timeCaption="Time"
                          dateFormat="dd MMM yyyy h:mm aa"
                          minDate={new Date()}
                          placeholderText="Select follow-up date & time"
                          className="w-full"
                          calendarClassName="custom-datepicker"
                          popperClassName="custom-datepicker-popper"
                          popperPlacement="bottom-start"
                          portalId="root"
                        />
                      </FieldWrappers>
                      {errors.date && touched.date && (
                        <ErrorText>{errors.date}</ErrorText>
                      )}
                    </InputGroup>
                    {values.stage === 3 && (
                      <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 space-y-4">
                        <div className="flex items-center justify-between">
                          <p className="text-sm font-semibold text-gray-700">
                            Negotiation Details
                          </p>
                        </div>

                        {/* Rent Expectation */}
                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <Label className="mb-1 block text-xs">
                              Tenant Budget
                            </Label>
                            <FieldWrappers>
                              <RupeeIcon />
                              <Field
                                type="number"
                                name="tenantBudget"
                                placeholder="Tenant offer"
                                className="pl-5 w-full"
                              />
                            </FieldWrappers>
                          </div>

                          <div>
                            <Label className="mb-1 block text-xs">
                              Owner Expectation
                            </Label>
                            <FieldWrappers>
                              <RupeeIcon />
                              <Field
                                type="number"
                                name="ownerExpected"
                                placeholder="Owner demand"
                                className="pl-5 w-full"
                              />
                            </FieldWrappers>
                          </div>
                        </div>

                        {/* Gap Indicator */}
                        <div className="bg-white border rounded-lg p-3 text-sm">
                          <span className="text-gray-500">Negotiation Gap</span>
                          <p className="text-orange-600 font-semibold">
                            {/* ₹ {(values.tenantBudget || 0) - (values.ownerExpected || 0)} */}
                            ₹{" "}
                            {Math.abs(
                              (values.ownerExpected || 0) -
                                (values.tenantBudget || 0),
                            )}
                          </p>
                        </div>

                        {/* Negotiation Status */}
                        <div>
                          <Label className="mb-1 block text-xs">
                            Negotiation Status
                          </Label>
                          <div className="grid grid-cols-2 gap-2">
                            {[
                              "ONGOING",
                              "OWNER_AGREED",
                              "TENANT_AGREED",
                              "FINAL_DISCUSSION",
                            ].map((option) => (
                              <button
                                key={option}
                                type="button"
                                onClick={() =>
                                  setFieldValue(
                                    "negotiationStatus",
                                    DEAL_NEGOTIATION_STATUS[option],
                                  )
                                }
                                className={`py-2 rounded-lg text-sm font-medium transition
                                ${
                                    values.negotiationStatus ===
                                    DEAL_NEGOTIATION_STATUS[
                                    option
                                    ]
                                    ? "bg-primary-color text-white"
                                    : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-100"
                                }`}
                              >
                                {option.replace("_", " ")}{" "}
                                {/* optional: nicer display */}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Notes */}
                    <InputGroup>
                      <Label htmlFor="note">Notes</Label>
                      <Textarea
                        id="note"
                        name="note"
                        className="w-full h-20"
                        placeholder="Enter any additional notes..."
                        value={values.note}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {/* {errors.note && touched.note && (
                            <ErrorText>{errors.note}</ErrorText>
                        )} */}
                    </InputGroup>
                  </Wrapper>
                </ScrollableContent>

                <ActionSection>
                  <SideCancelBtn
                    type="button"
                    onClick={() => {
                      resetForm();
                      handleClose();
                    }}
                  >
                    Cancel
                  </SideCancelBtn>
                  <SubmitBtn type="submit">
                    {addDealLoading ? "Submiting..." : "Submit"}
                  </SubmitBtn>
                </ActionSection>
                <SelectOptionModal
                  isOpen={isStageModalOpen}
                  onClose={() => setIsStageModalOpen(false)}
                  title="Select Stage"
                  options={stageOption}
                  selectedValue={values.stage}
                  onSelect={handleStageSelect}
                  searchPlaceholder="Search stage..."
                />
              </Form>
            );
          }}
        </Formik>
      </div>
    </Container>
  );
};
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-gradient-to-r from-primary-color to-teal-400 py-4 px-4`;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;

export default AddDeal;
